import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { App } from './App';
import { LoginPage } from './pages/Login';
import { ConnectPage } from './pages/Connect';
import { BackfillPage } from './pages/Backfill';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route path="/" element={<Navigate to="/connect" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/connect" element={<ConnectPage />} />
          <Route path="/backfill" element={<BackfillPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
